import * as React from 'react';
import './timePicker.scss';
import { ReactComponent as ClockIcon } from '../../assets/icons/icon_clock.svg';
import { ReactComponent as DashIcon } from '../../assets/icons/dash.svg';

interface Props {
    setData: Function;
}

const TimePicker: React.FC<Props> = ({ setData }) => {
    const today = new Date();
    const time = ('0' + today.getHours()).slice(-2) + ':' + ('0' + today.getMinutes()).slice(-2);
    const [timeRange, setTimeRange] = React.useState<any>({
        startTime: time,
        endTime: time,
    });

    const handleFormData = (event: any) => {
        setTimeRange((values: any) => ({ ...values, [event.target.name]: event.target.value }));
        setData(timeRange);
    };

    return (
        <div className="timePickerComponent">
            <div className="leftContainerItems">
                <div className="iconLeft">
                    <ClockIcon />
                </div>

                <input
                    className="inputLeft"
                    name="startTime"
                    type="time"
                    onChange={handleFormData}
                    value={timeRange.startTime}
                />
            </div>

            <div className="dashIcon">
                <DashIcon />
            </div>

            <div className="rightContainerItems">
                <div className="iconRight">
                    <ClockIcon />
                </div>
                <input
                    className="inputRight"
                    name="endTime"
                    type="time"
                    onChange={handleFormData}
                    value={timeRange.endTime}
                />
            </div>
        </div>
    );
};
export default TimePicker;
